module.exports = "https://static.im-cdn.com/mjc/storefront/Coral/static/media/Pinterest.b00a3bad.svg";